/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/accordion/custom-elements';

import { defineCustomElement as defineOsdsAccordion } from '@ovhcloud/ods-stencil/components/accordion/custom-elements/osds-accordion.js';
import { defineCustomElement as defineOsdsAccordionGroup } from '@ovhcloud/ods-stencil/components/accordion/custom-elements/osds-accordion-group.js';


export const OsdsAccordion = /*@__PURE__*/ defineContainer<JSX.OsdsAccordion>('osds-accordion', defineOsdsAccordion, [
  'color',
  'contrasted',
  'size',
  'disabled',
  'opened',
  'odsAccordionToggle'
]);


export const OsdsAccordionGroup = /*@__PURE__*/ defineContainer<JSX.OsdsAccordionGroup>('osds-accordion-group', defineOsdsAccordionGroup);

